import { Box, Stack, Tab, Tabs, Typography } from '@mui/material'
import { useLayoutEffect, useState } from 'react'
import { PrivacySection } from './sections/PrivacySection'
import { NotificationsSection } from './sections/NotificationsSection'
import { BlockingAndCommunicationSection } from './sections/BlockingAndCommunicationSection'
import { AccountDangerSection } from './sections/AccountDangerSection'
import { TabsStyle } from './style'
import { useGetProfileQuery } from '../../../api/profile'

type SettingsSectionKey = 'privacy' | 'notifications' | 'blockingAndCommunication'

export const Settings = () => {
  useLayoutEffect(() => {
    document.title = 'Настройки'
  }, [])

  const { data: profile } = useGetProfileQuery()
  const [activeSection, setActiveSection] = useState<SettingsSectionKey>('privacy')

  const handleSectionChange = (_: React.SyntheticEvent, value: SettingsSectionKey) => {
    setActiveSection(value)
  }

  return (
    <Stack pt={{ xs: '15px', md: '50px' }} justifyContent="center" alignItems="center" px={1.5}>
      <Box sx={{ maxWidth: { xs: '736px', md: '840px' }, width: '100%' }}>
        <Typography variant="h1" component="div" mb={2} px={{ xs: 0, md: 2.5 }}>
          Настройки
        </Typography>

        <Stack direction="column" gap={{ xs: 1.5, sm: 2 }} mb={3}>
          <Tabs
            value={activeSection}
            onChange={handleSectionChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={TabsStyle}
          >
            <Tab value="privacy" label="Приватность" />
            <Tab value="notifications" label="Уведомления" />
            <Tab value="blockingAndCommunication" label="Блокировки" />
          </Tabs>
        </Stack>

        {activeSection === 'privacy' && <PrivacySection />}
        {activeSection === 'notifications' && <NotificationsSection />}
        {activeSection === 'blockingAndCommunication' && <BlockingAndCommunicationSection />}

        {profile?.id != null && (
          <Stack mt={3}>
            <AccountDangerSection userId={profile.id} />
          </Stack>
        )}
      </Box>
    </Stack>
  )
}
